import React from 'react';

function LabelAndText(props: {
    label: string;
    text: string | number | React.JSX.Element;
    className?: string;
}): React.JSX.Element {
    return (
        <div className={` ${props.className}`}>
            <label className="uppercase font-montserrat-semibold">{props.label}</label>
            <div className="mt-5">{props.text}</div>
        </div>
    );
}
export default LabelAndText;
